import { useCallback, useMemo } from 'react'
import { useRouter } from 'next/router'

import { QUERY_PARAMS } from '@/constants'
import { getQueryParamValueAsString } from '@/utils/url'

const useInvitation = () => {
  const router = useRouter()

  const email = getQueryParamValueAsString(QUERY_PARAMS.invitationEmail, router.query)
  const name = getQueryParamValueAsString(QUERY_PARAMS.invitationName, router.query)
  const type = getQueryParamValueAsString(QUERY_PARAMS.invitationType, router.query)

  const clearUserInfo = useCallback(() => {
    const nextParams = { ...router.query }
    delete nextParams[QUERY_PARAMS.invitationName]
    delete nextParams[QUERY_PARAMS.invitationEmail]
    router.replace({ pathname: router.pathname, query: nextParams })
  }, [router.pathname, router.query])

  return useMemo(
    () => ({
      type,
      email,
      name,
      clearUserInfo,
    }),
    [type, email, name, clearUserInfo],
  )
}

export default useInvitation
